<template>
    <div class="ammountBox">
        <div class="h2">
            Select an amount to load
        </div>
        <div class="ammounts">
            <md-radio v-model="gcard.amount" checked value="10">$10</md-radio>
            <md-radio v-model="gcard.amount" value="25">$25</md-radio>
            <md-radio v-model="gcard.amount" value="50">$50</md-radio>
            <md-radio v-model="gcard.amount" value="100">$100</md-radio>
            <md-radio v-model="gcard.amount" value="custom" class="cust">Custom Amount</md-radio>
            <div class="custom_ammount" v-if="gcard.amount == 'custom'">
                <input type="number" v-model="gcard.custom_ammount" @keyup="changeCustomAmount" placeholder="Custom amount...">
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "GiftCardAmount",
        props:["gcard"],
        methods:{
            changeCustomAmount(e) {
                const el = e.currentTarget;
                this.gcard.custom_ammount = el.value.replace(/[^\d]/g, '').replace(/(\d\d?)$/, '.$1').replace(/^0+/, '');
                this.gcard.custom_ammount = this.gcard.custom_ammount ? this.gcard.custom_ammount : 0;
            }
        }
    }
</script>
